import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ModalState {
  openModal: boolean;
  recordKey: string;
  type?: string;
  params?: { [key: string]: string | number };
}

const initialState: ModalState = {
  openModal: false,
  recordKey: '',
  type: '',
  params: {},
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    setStatusModal: (
      state: ModalState,
      action: PayloadAction<{
        status: boolean;
        key: string;
        type?: string;
        params?: { [key: string]: string | number };
      }>
    ) => {
      state.openModal = action.payload.status;
      state.recordKey = action.payload.key;
      state.type = action.payload.type;
      state.params = action.payload.params;
    },
  },
});

const { actions } = modalSlice;

export const modalActions = {
  ...actions,
};

export default modalSlice;
